/** 所傳入 [states] props 的 index */
export const index = {
  addressCityId: 0,
  addressCity: 1,
  addressTownId: 2,
  addressTown: 3,
  addressZip: 4,
  address: 5,
};
